/*
 * @Author: wangqi angelqiqiwang@shjinjia.com.cn
 * @Date: 2024-06-25 15:06:55
 * @LastEditors: wangqi angelqiqiwang@shjinjia.com.cn
 * @LastEditTime: 2024-07-30 11:24:44
 * @FilePath: \oak\src\store\modules\routerMap\views\kolPurchase.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const map = {
  KolPickOrderDetail: () => import('@/views/kolPurchase/KolPickOrderModule/Detail'),
  PromotionplanList: () => import('@/views/kolPurchase/Promotionplan/index'),
  PromotionplanDetail: () => import('@/views/kolPurchase/Promotionplan/Detail'),
  PromotionWorkbenchDetail: () => import('@/views/kolPurchase/PromotionWorkbench/Detail'),
  CelebPromoteServiceContentConfigList: () => import('@/views/kolPurchase/CelebPromoteServiceContentConfig/index'),
  CelebPromoteServiceContentConfigDetail: () => import('@/views/kolPurchase/CelebPromoteServiceContentConfig/Detail'),
  PromotionPlanApplicantDetails: () => import('@/views/kolPurchase/PromotionPlanApplicantDetails/index'),
  DocumentTransferList: () => import('@/views/kolPurchase/DocumentTransfer/index'),
  DocumentTransferDetails: () => import('@/views/kolPurchase/DocumentTransfer/Detail'),
  PromotionDetailsApproval: () => import('@/views/kolPurchase/PromotionDetailsApproval/index'),
  celebLaunchModule: () => import('@/views/kolPurchase/CelebLaunchModule/index'), // 推广发布列表
  celebResultModuleList: () => import('@/views/kolPurchase/CelebResultModule/index'), // 推广验收列表
  celebResultModuleDetail: () => import('@/views/kolPurchase/CelebResultModule/Detail'), // 推广验收详情
  promotionDetailsList: () => import('@/views/kolPurchase/PromotionDetailsList/index'), // 推广执行明细列表
  CelebPromoteRecordModule: () => import('@/views/kolPurchase/CelebPromoteRecordModule/index'), // 推广结算明细列表
  RedManPrimaryPool: () => import('@/views/kolPurchase/RedManPrimaryPool/index'), // 红人初选池列表
  celebKolStorageModule: () => import('@/views/kolPurchase/CelebKolStorageModule/index'), // 	推广SRM入库列表
  WorkDashboard: () => import('@/views/kolPurchase/WorkDashboard/index'), // 	工作仪表盘
  PromoteCalendar: () => import('@/views/kolPurchase/PromoteCalendar/index'), // 	推广日历
  CelebPlatformBrandLevelDetail: () => import('@/views/kolPurchase/CelebPlatformBrandLevel/Detail'), // 	品牌级别详情
  CelebPromoteBrandPaymentConfigModuleDetail: () => import('@/views/kolPurchase/CelebPromoteBrandPaymentConfigModule/Detail'), // 	品牌付款配置详情
  CelebKolStorageDetailModule: () => import('@/views/kolPurchase/CelebKolStorageDetailModule/index'), // 	推广SRM入库详情
  CelebKolFinanceSettlementCloseConfigModule: () => import('@/views/kolPurchase/CelebKolFinanceSettlementCloseConfig/Detail'), // 	推广结算关账配置详情
  ApprovalMatrixList: () => import('@/views/kolPurchase/ApprovalMatrix/index'), // 	推广结算关账配置详情
  ApprovalMatrixDetail: () => import('@/views/kolPurchase/ApprovalMatrix/Detail'), // 	推广结算关账配置详情
  ApprovalBusinessDetail: () => import('@/views/kolPurchase/ApprovalMatrix/ApprovalBusinessDetail'), // 	推广结算关账配置详情
  BeautyAssets: () => import('@/views/kolPurchase/BeautyAssets/index'), // 	美资系统
  XhsCelebrityRecommendation: () => import('@/views/kolPurchase/XhsCelebrityRecommendation/index') // 	小红书内部达人推荐
}

export default map
